import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ConsumerInsightArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-119.000000, -46.000000)"
      >
        <g transform="translate(119.000000, 46.000000)">
          <path
            d="M-0.0001,15 C-0.0001,23.284 6.7159,30 14.9999,30 C23.2839,30 29.9999,23.284 29.9999,15 C29.9999,6.715 23.2839,0 14.9999,0 C6.7159,0 -0.0001,6.715 -0.0001,15"
            fill="#EB9500"
          />
          <polyline
            points="5.9999 8.6171 5.9999 22.2581 24.9999 22.2581"
            stroke="#ffffff"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={styles.whiteStroke}
          />
          <path
            d="M15.7723,20.0844 L15.0503,20.0844 C14.7913,20.0844 14.5803,19.8744 14.5803,19.6144 L14.5803,11.4924 C14.5803,11.2354 14.7883,11.0284 15.0443,11.0284 L15.7723,11.0284 C16.0323,11.0284 16.2423,11.2384 16.2423,11.4984 L16.2423,19.6144 C16.2423,19.8744 16.0323,20.0844 15.7723,20.0844"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M19.1727,20.0844 L18.2977,20.0844 C18.0807,20.0844 17.9037,19.9084 17.9037,19.6914 L17.9037,14.1384 C17.9037,13.9204 18.0807,13.7454 18.2977,13.7454 L19.1727,13.7454 C19.3897,13.7454 19.5667,13.9204 19.5667,14.1384 L19.5667,19.6914 C19.5667,19.9084 19.3897,20.0844 19.1727,20.0844"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M22.8812,20.0844 L22.1962,20.0844 C21.9262,20.0844 21.7082,19.8664 21.7082,19.5964 L21.7082,10.7924 C21.7082,10.5224 21.9262,10.3034 22.1962,10.3034 L22.8812,10.3034 C23.1512,10.3034 23.3702,10.5224 23.3702,10.7924 L23.3702,19.5964 C23.3702,19.8664 23.1512,20.0844 22.8812,20.0844"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M12.4984,20.0844 L11.6774,20.0844 C11.4454,20.0844 11.2564,19.8964 11.2564,19.6644 L11.2564,13.2594 C11.2564,13.0274 11.4454,12.8394 11.6774,12.8394 L12.4984,12.8394 C12.7304,12.8394 12.9184,13.0274 12.9184,13.2594 L12.9184,19.6644 C12.9184,19.8964 12.7304,20.0844 12.4984,20.0844"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M9.4471,20.0844 L8.5241,20.0844 C8.3201,20.0844 8.1551,19.9194 8.1551,19.7154 L8.1551,16.8314 C8.1551,16.6274 8.3201,16.4614 8.5241,16.4614 L9.4471,16.4614 C9.6511,16.4614 9.8171,16.6274 9.8171,16.8314 L9.8171,19.7154 C9.8171,19.9194 9.6511,20.0844 9.4471,20.0844"
            fill="#ffffff"
            className={styles.white}
          />
          <polyline
            points="8.6981 10.8471 16.3051 6.5001 18.4791 9.7601 22.8261 7.5861"
            stroke="#ffffff"
            strokeWidth="0.543"
            className={styles.whiteStroke}
          />
        </g>
      </g>
    </Icon>
  )
}
